import styled from '@emotion/styled'
import { font, shadow, spacing, colors } from '@mobi/component-library/Theme/Common'

export const BannerContainerStyled = styled.div({
  display: 'flex',
  position: 'relative',
  alignItems: 'center', // align the background image
  overflow: 'hidden', // stop the background image from overflowing as it grows based on screen size

  height: '2.4rem',
  padding: `${spacing.smx1} 0`,

  background: colors.warning[700],
  boxShadow: shadow.sm,
  lineHeight: spacing.none,
})

export const BannerContentStyled = styled.div({
  position: 'absolute', // draw over the top of the sibling background image

  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx1,

  margin: `0 ${spacing.md}`,

  color: 'white',
  fontFamily: font.family.primary,
  fontSize: font.size.xl.fontSize,
  fontWeight: font.weight.semibold,
  lineHeight: font.size.xl.lineHeight,
})
